import { render, staticRenderFns } from "./rewardPosterEdit.vue?vue&type=template&id=cc8b5036&scoped=true&"
import script from "./rewardPosterEdit.vue?vue&type=script&lang=js&"
export * from "./rewardPosterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b5036",
  null
  
)

export default component.exports